import React, { memo, forwardRef } from "react";
const SvgSquarebrackets1 = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        stroke="#717171"
        strokeWidth={0.2}
        d="M14.84 27.84h2.7c.366 0 .659-.092.86-.293.2-.2.292-.494.292-.86V4.817c0-.366-.092-.66-.293-.86-.2-.201-.494-.293-.86-.293h-2.7c-.283 0-.514.063-.674.208-.163.146-.236.36-.236.621s.073.475.236.621c.16.145.391.208.674.208h1.871v20.86h-1.87c-.284 0-.515.063-.675.208-.163.146-.236.36-.236.621s.073.475.236.621c.16.144.391.208.674.208z"
      />
    </svg>
  );
});
SvgSquarebrackets1.displayName = "SvgSquarebrackets1";
const MemoForwardRef = memo(SvgSquarebrackets1);
export default MemoForwardRef;
